<template>
  <div class="modal fade" ref="modal" tabindex="-1" aria-labelledby="refreshModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="refreshModalLabel">New Version Available</h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          A new version of the app is available. Please refresh the page to load the latest version.<br>
          <strong>Note:</strong> If you don't want to lose your current work, close this modal window and finish your work before refreshing.
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">Close</button>
          <button type="button" class="btn btn-primary" @click="refreshPage">Refresh Now</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap';
export default {
  name: "RefreshModal",
  data() {
    return {
      modalInstance: null,
    };
  },
  methods: {
    refreshPage() {
      window.location.reload(true);
    },
    show() {
      this.modalInstance = new Modal(this.$refs.modal);
      this.modalInstance.show();
    },
    closeModal() {
      if (this.modalInstance) {
        this.modalInstance.hide();
      }
    },
  },
};
</script>
